var map = {
  "./add_users.svg": "179815",
  "./admin-icon-surveys.svg": "695146",
  "./advanced.svg": "925819",
  "./badges.svg": "814357",
  "./bamboo.svg": "672313",
  "./bounced_email.svg": "628522",
  "./calendar_integration.svg": "520280",
  "./company_directory.svg": "835942",
  "./custom_wording.svg": "456757",
  "./date_and_time.svg": "627709",
  "./default.svg": "143112",
  "./design.svg": "946311",
  "./email_reports.svg": "151871",
  "./emails.svg": "770710",
  "./event_log.svg": "405388",
  "./feature_selection.svg": "436150",
  "./g2_review.svg": "850137",
  "./gmail.svg": "84493",
  "./google.svg": "775376",
  "./helpful_resources.svg": "915463",
  "./hipchat.svg": "691862",
  "./import_users.svg": "371619",
  "./kallidus.svg": "845174",
  "./latest_exports.svg": "24756",
  "./license_payment.svg": "561085",
  "./mail_log.svg": "424987",
  "./message.svg": "862650",
  "./message_stats.svg": "350858",
  "./module-1on1s-icon.svg": "847718",
  "./module-360-icon.svg": "196779",
  "./module-objectives-icon.svg": "691352",
  "./module-reviews-icon.svg": "509565",
  "./namely.svg": "276329",
  "./personio.svg": "745590",
  "./praise.svg": "499449",
  "./progress_o_meter.svg": "856928",
  "./referral_program.svg": "862547",
  "./request_feedback.svg": "382454",
  "./rippling.svg": "901578",
  "./saml_sso.svg": "489246",
  "./sample_content.svg": "129573",
  "./security.svg": "653123",
  "./slack.svg": "883731",
  "./user_setting.svg": "399709",
  "./workable.svg": "241354",
  "./workday.svg": "253912"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 615985;
